import React, { useEffect, useState } from "react";
import { Row, Col } from "reactstrap";
import { connect, useStore } from "react-redux";
import { motion } from "framer-motion";
import { fadeVariants } from "../../../../components/shared/utils/animations";

const AllWords = (props) => {
  const [guessedWords, setGuessed] = useState([]);
  const [buzzledWords, setBuzzled] = useState([]);
  const [skippedWords, setSkipped] = useState([]);
  useEffect(() => {
    let roomData = props.gameReducer.roomObj;
    let guessedWords = [];
    let buzzledWords = [];
    let skippedWords = [];
    if (roomData && roomData.game_state) {
      if (roomData.game_state.current_team) {
        const currentTeam = roomData.game_state.current_team;
        if (currentTeam === "A") {
          guessedWords = roomData.game_state.right_words_a;
          skippedWords = roomData.game_state.skipped_words_a;
          buzzledWords = roomData.game_state.missed_words_a;
        } else {
          guessedWords = roomData.game_state.right_words_b;
          skippedWords = roomData.game_state.skipped_words_b;
          buzzledWords = roomData.game_state.missed_words_b;
        }
        setGuessed(guessedWords);
        setBuzzled(buzzledWords);
        setSkipped(skippedWords);
      }
    }
  }, [props.gameReducer.roomObj]);

  const gameObj = props.paramsReducer.gameObj;
  let guessedHeader = "GUESSED";
  let skippedHeader = "SKIPPED";
  let buzzedHeader = "BUZZED";
  if (gameObj) {
    if (gameObj && gameObj.screens && gameObj.screens.vb) {
      guessedHeader = gameObj.screens.vb.guessed_label;
      skippedHeader = gameObj.screens.vb.skipped_label;
      buzzedHeader = gameObj.screens.vb.missed_label;
    }
  }
  return (
    <motion.div
      variants={fadeVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="gbs-wrapper"
    >
      <Row>
        <Col sm={4}>
          <div className="gbs-col first">
            <h2 className="text-uppercase text-lightGreen">
              {guessedHeader} <span>({guessedWords.length})</span>
            </h2>
            <div className="gbs-text">
              {guessedWords &&
                guessedWords.length > 0 &&
                guessedWords.map((word) => {
                  return <p className="text">{word}</p>;
                })}
            </div>
          </div>
        </Col>
        <Col sm={4}>
          <div className="gbs-col">
            <h2 className="text-uppercase text-darkRed">
              {buzzedHeader} <span>({buzzledWords.length})</span>
            </h2>
            <div className="gbs-text">
              {buzzledWords &&
                buzzledWords.length > 0 &&
                buzzledWords.map((word) => {
                  return <p className="text">{word}</p>;
                })}
            </div>
          </div>
        </Col>
        <Col sm={4}>
          <div className="gbs-col last">
            <h2 className="text-uppercase text-orange">
              {skippedHeader} <span>({skippedWords.length})</span>
            </h2>
            <div className="gbs-text">
              {skippedWords &&
                skippedWords.length > 0 &&
                skippedWords.map((word) => {
                  return <p className="text">{word}</p>;
                })}
            </div>
          </div>
        </Col>
      </Row>
    </motion.div>
  );
};

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  loaderDetails: state.loaderDetails,
  paramsReducer: state.paramsReducer
});

export default connect(mapStateToProps, null)(AllWords);
